/* Sprayground giveaway landing page. All config arrives on #gv-root data-attributes
   so this file stays a cacheable static asset with no Liquid in it. */
(function () {
  "use strict";

  var root = document.getElementById("gv-root");
  if (!root) return;
  var cfg = root.dataset;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var MOBILE = window.matchMedia("(max-width: 759px)");
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var conn = navigator.connection || {};
  /* Egyptian mobile data: never pull a video on save-data or a 2g-class link */
  var thrifty = reduce || conn.saveData || /(^|\W)2g/.test(conn.effectiveType || "");

  /* attach an mp4 source only when it is worth the bytes */
  function loadVideo(video, src, posterEl) {
    if (!video) return;
    if (!src || thrifty) { video.style.display = "none"; return; }
    var s = document.createElement("source");
    s.src = src; s.type = "video/mp4";
    video.appendChild(s);
    video.load();
    /* hold the still underneath until the first frame decodes, else the swap flashes */
    if (posterEl) video.addEventListener("playing", function () { posterEl.style.display = "none"; }, { once: true });
  }

  /* ---------- hero ----------
     Portrait 9:16 loop on phones, 16:9 on desktop. Both are typeless: the headline is
     real HTML on top, so nothing is baked into the video and nothing gets cropped. */
  var heroPortrait = MOBILE.matches;
  var heroPoster = $("#gv-poster");
  if (heroPoster) heroPoster.src = heroPortrait ? cfg.posterMobile : cfg.posterDesktop;
  var heroVid = $("#gv-herovid");
  if (heroVid) heroVid.poster = heroPortrait ? cfg.posterMobile : cfg.posterDesktop;
  loadVideo(heroVid, heroPortrait ? cfg.heroMobile : cfg.heroDesktop, heroPoster);

  /* ---------- referral video ---------- */
  var refVid = $("#gv-refvid");
  if (refVid) {
    var refSquare = MOBILE.matches;
    refVid.poster = refSquare ? cfg.referralPosterMobile : cfg.referralPoster;
    loadVideo(refVid, refSquare ? cfg.referralMobile : cfg.referralDesktop, null);
  }

  /* ---------- countdown ---------- */
  var clock = $("#gv-clock"), sticky = $("#gv-sticky"), stickyClock = $("#gv-stickyclock");
  var end = cfg.deadline ? new Date(cfg.deadline).getTime() : NaN;
  var pad = function (n) { return n < 10 ? "0" + n : "" + n; };
  function tick() {
    var left = end - Date.now();
    if (left < 0) left = 0;
    var d = Math.floor(left / 86400000),
        h = Math.floor(left / 3600000) % 24,
        m = Math.floor(left / 60000) % 60,
        sec = Math.floor(left / 1000) % 60;
    $("[data-d]", clock).textContent = pad(d);
    $("[data-h]", clock).textContent = pad(h);
    $("[data-m]", clock).textContent = pad(m);
    $("[data-s]", clock).textContent = pad(sec);
    if (stickyClock) stickyClock.textContent = d + "d " + pad(h) + "h";
  }
  if (clock && !isNaN(end)) { tick(); setInterval(tick, 1000); }

  /* sticky bar: only once the form is off-screen. Body padding stops it covering
     the last of the page content while it is up. */
  var enter = $("#gv-enter");
  if (sticky && enter && "IntersectionObserver" in window) {
    new IntersectionObserver(function (es) {
      var on = !es[0].isIntersecting && window.scrollY > 400;
      sticky.classList.toggle("on", on);
      document.body.classList.toggle("gv-stuck", on && MOBILE.matches);
    }, { threshold: 0 }).observe(enter);
  }

  /* ---------- bag picker ----------
     Hard cap of three. On phones the grid is not a nested scroll box (that traps the
     page scroll), so everything past the first 12 tiles hides behind Show all. */
  var boxes = $$("#gv-picker input[type='checkbox']");
  var tiles = $$("#gv-picker .gv-bag");
  var countEl = $("#gv-count");
  var moreBtn = $("#gv-more");
  var VISIBLE = 12;

  function applyCollapse() {
    var collapse = MOBILE.matches && tiles.length > VISIBLE;
    tiles.forEach(function (t, i) { t.classList.toggle("gv-hidden", collapse && i >= VISIBLE); });
    if (moreBtn) {
      moreBtn.classList.toggle("on", collapse);
      moreBtn.textContent = "Show all " + tiles.length + " designs";
    }
  }
  if (moreBtn) moreBtn.addEventListener("click", function () {
    tiles.forEach(function (t) { t.classList.remove("gv-hidden"); });
    moreBtn.classList.remove("on");
  });
  applyCollapse();
  (MOBILE.addEventListener ? MOBILE.addEventListener.bind(MOBILE, "change") : MOBILE.addListener.bind(MOBILE))(applyCollapse);

  function chosen() { return boxes.filter(function (b) { return b.checked; }); }

  /* Once the third bag lands there is nothing left to do in the picker, so carry them
     to the finish rather than making them hunt for the button. Guarded so it never
     fires on load — browsers restore checkbox state on back-navigation. */
  var lastCount = 0, pickerReady = false;
  function sync() {
    var n = chosen().length;
    if (countEl) countEl.innerHTML = "<b>" + n + "</b> of 3 chosen";
    boxes.forEach(function (b) { b.disabled = (!b.checked && n >= 3); });
    if (pickerReady && n === 3 && lastCount < 3) {
      var target = $("#gv-submit");
      if (target) {
        /* let the tick and disabled-state repaint settle, or Safari drops the scroll */
        setTimeout(function () {
          target.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });
        }, 200);
      }
    }
    lastCount = n;
  }
  boxes.forEach(function (b) { b.addEventListener("change", sync); });
  sync();
  pickerReady = true;

  /* ---------- phone ----------
     Klaviyo silently DISCARDS anything that is not already E.164 — verified against the
     live API: posting "01001234567" returns 202 and the profile comes back with
     phone_number: null. The entry saves, the number is gone. So normalise here rather
     than trusting what was typed.
     Egyptian mobiles are 010/011/012/015 + 8 digits => +20 1[0125] + 8 digits. */
  function normalisePhone(v) {
    var d = String(v || "").replace(/[^\d+]/g, "").replace(/^\+/, "");
    if (d.indexOf("00") === 0) d = d.slice(2);
    if (d.indexOf("20") === 0) d = d.slice(2);
    d = d.replace(/^0+/, "");
    return /^1[0125]\d{8}$/.test(d) ? "+20" + d : "";
  }

  var phoneEl = $("#gv-phone");
  var phoneHint = $("#gv-phonehint");
  var phoneHintDefault = phoneHint ? phoneHint.textContent : "";
  if (phoneEl && phoneHint) {
    phoneEl.addEventListener("blur", function () {
      var n = normalisePhone(phoneEl.value);
      if (n) {
        phoneEl.value = n;
        phoneHint.textContent = "Looks good — we will use this to reach you if you win.";
        phoneHint.style.color = "#7BD88F";
      } else if (phoneEl.value.trim()) {
        phoneHint.textContent = "That does not look like an Egyptian mobile number.";
        phoneHint.style.color = "#FF6B6B";
      } else {
        phoneHint.textContent = phoneHintDefault;
        phoneHint.style.color = "";
      }
    });
  }

  /* ---------- referral code ----------
     Deterministic hash of the email, so entering twice yields the same link and a
     mother's referrals never split across two codes. */
  function codeFor(email) {
    var h = 2166136261;
    var e = String(email).trim().toLowerCase();
    for (var i = 0; i < e.length; i++) { h ^= e.charCodeAt(i); h = Math.imul(h, 16777619); }
    return ("000000" + (h >>> 0).toString(36).toUpperCase()).slice(-6);
  }

  var incoming = (new URLSearchParams(location.search).get("ref") || "").trim().toUpperCase().slice(0, 12);
  var refInput = $("#gv-ref");
  if (incoming && refInput) refInput.value = incoming;

  /* ---------- submit ---------- */
  var form = $("#gv-form"), errEl = $("#gv-error"), btn = $("#gv-submit");
  function fail(msg) {
    errEl.textContent = msg;
    errEl.classList.add("on");
    errEl.scrollIntoView({ block: "center", behavior: "smooth" });
  }

  if (form) form.addEventListener("submit", function (ev) {
    ev.preventDefault();
    errEl.classList.remove("on");

    var email = $("#gv-email").value.trim();
    var phone = normalisePhone(phoneEl ? phoneEl.value : "");
    var kids = $("#gv-kids").value;
    var school = $("#gv-school").value.trim();
    var bags = chosen().map(function (b) { return b.value; });

    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return fail("Please enter a valid email address.");
    if (!phone) return fail("Please enter a valid Egyptian mobile number — for example 010 1234 5678.");
    if (!kids) return fail("Please tell us how many kids need a bag.");
    if (!school) return fail("Please tell us the school name.");
    if (bags.length !== 3) return fail("Please pick exactly three bags — you have " + bags.length + ".");
    if (!$("#gv-ig").checked) return fail("Following on Instagram is required to enter.");
    if (!$("#gv-consent").checked) return fail("Please accept the rules to enter.");

    btn.disabled = true;
    btn.textContent = "Entering…";

    var code = codeFor(email);
    var link = cfg.pageUrl + "?ref=" + code;
    var props = {
      giveaway: "Sprayground Aug 2026",
      giveaway_kids: kids,
      giveaway_school: school,
      giveaway_phone: phone,
      giveaway_bag_1: bags[0],
      giveaway_bag_2: bags[1],
      giveaway_bag_3: bags[2],
      giveaway_bags: bags.join(" | "),
      giveaway_referral_code: code,
      giveaway_referred_by: refInput ? refInput.value : "",
      giveaway_entered_at: new Date().toISOString()
    };
    /* phone_number is Klaviyo's reserved field — segmentable and usable for SMS/WhatsApp.
       giveaway_phone is a plain-text mirror so the number still survives in the profile
       even if Klaviyo ever rejects the reserved field. */
    var profileAttrs = { email: email, phone_number: phone, properties: props };
    var kv = function (path) {
      return "https://a.klaviyo.com/client/" + path + "/?company_id=" + encodeURIComponent(cfg.company);
    };
    var headers = { "content-type": "application/json", revision: "2024-10-15" };

    /* 1. subscribe + persist the answers as profile properties */
    var subscribe = fetch(kv("subscriptions"), {
      method: "POST", headers: headers,
      body: JSON.stringify({ data: { type: "subscription", attributes: {
        custom_source: "Sprayground Giveaway Landing Page",
        profile: { data: { type: "profile", attributes: profileAttrs } }
      }, relationships: { list: { data: { type: "list", id: cfg.list } } } } })
    });

    /* 2. a discrete event, so flows and reporting have a trigger */
    var event = fetch(kv("events"), {
      method: "POST", headers: headers,
      body: JSON.stringify({ data: { type: "event", attributes: {
        properties: props,
        metric: { data: { type: "metric", attributes: { name: "Entered Giveaway" } } },
        profile: { data: { type: "profile", attributes: profileAttrs } }
      } } })
    });

    /* 3. native Shopify contact form, posted in the background as a redundant record */
    var sf = document.getElementById("gv-shopify-form");
    var shopify = Promise.resolve();
    if (sf) {
      $("#gv-sf-email").value = email;
      $("#gv-sf-phone").value = phone;
      $("#gv-sf-kids").value = kids;
      $("#gv-sf-school").value = school;
      $("#gv-sf-bags").value = bags.join(" | ");
      $("#gv-sf-code").value = code;
      $("#gv-sf-ref").value = refInput ? refInput.value : "";
      $("#gv-sf-body").value = "Giveaway entry — " + kids + " kids at " + school +
        ". Phone " + phone + ". Bags: " + bags.join(", ") + ". Referral code " + code + ".";
      shopify = fetch(sf.action, { method: "POST", body: new FormData(sf) }).catch(function () {});
    }

    if (typeof window.fbq === "function") {
      try { window.fbq("track", "Lead", { content_name: "Sprayground Giveaway Aug 2026", currency: "EGP", value: 0 }); } catch (e) {}
    }

    Promise.all([subscribe, event, shopify]).then(function (r) {
      /* the subscription is the call that must land; the other two are belt and braces */
      if (r[0] && !r[0].ok && r[0].status !== 202) throw new Error("subscribe " + r[0].status);
      $("#gv-formpanel").classList.add("off");
      var done = $("#gv-done");
      done.classList.add("on");
      $("#gv-reflink").value = link;
      var wa = $("#gv-wa");
      if (wa) wa.href = "https://wa.me/?text=" + encodeURIComponent(
        "I just entered to win 3 Sprayground backpacks from ESSENTIALS EGYPT — free to enter. " + link);

      /* the inbox card only matters once they have actually entered, so it is loaded
         here rather than on page load — it also cannot autoplay while display:none */
      var em = $("#gv-doneemail");
      if (em) em.textContent = email;
      var inbox = $("#gv-inboxvid");
      if (inbox) { if (cfg.inboxPoster) inbox.poster = cfg.inboxPoster; loadVideo(inbox, cfg.inbox, null); }

      done.scrollIntoView({ block: "center", behavior: "smooth" });
      try { sessionStorage.setItem("gv:entered", code); } catch (e) {}
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = "Enter the giveaway";
      fail("Something went wrong sending your entry. Please check your connection and try again.");
    });
  });

  /* ---------- copy link ---------- */
  var copy = $("#gv-copy");
  if (copy) copy.addEventListener("click", function () {
    var i = $("#gv-reflink");
    i.select();
    i.setSelectionRange(0, 99999); /* iOS needs the explicit range */
    var ok = false;
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(i.value); ok = true; }
    else { try { ok = document.execCommand("copy"); } catch (e) {} }
    copy.textContent = ok ? "Copied ✓" : "Press ⌘C";
    setTimeout(function () { copy.textContent = "Copy link"; }, 2200);
  });
})();
